import { render, staticRenderFns } from "./CXClientSettings.vue?vue&type=template&id=09a55f5a&scoped=true&"
import script from "./CXClientSettings.vue?vue&type=script&lang=js&"
export * from "./CXClientSettings.vue?vue&type=script&lang=js&"
import style0 from "./CXClientSettings.vue?vue&type=style&index=0&id=09a55f5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a55f5a",
  null
  
)

export default component.exports